import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import ReactTable from "react-table";
import "react-table/react-table.css";
import couterpart from 'counterpart';
import DatePicker from 'react-datepicker';
import {ToastsContainer, ToastsStore} from 'react-toasts';
import Spinner from 'react-spinner-material';

import { FaFilter } from 'react-icons/fa';
import Dialog from 'react-bootstrap-dialog';

import "react-table/react-table.css";
import "../css/style.css";
import MenuComponent2 from './MenuComponent2';

import WorkOrderUtil from '../utilities/WorkOrderUtil';
import MasterDataService from '../services/MasterDataService';
import AuthenticationService from '../services/AuthenticationService';
import { ICON_COLOR} from '../icon';
import queryString from 'query-string'
import HistoryService from '../services/HistoryService';

class HistoryList extends Component {
  constructor () {
    super();
    
    const numOfMonths = 24;
    let fromDate = new Date(new Date().getTime() - numOfMonths*30*24*60*60*1000*3);//1 month
    fromDate = WorkOrderUtil.convertToyyyyMMddhhmmString(fromDate);
    let toDate = new Date(new Date().getTime() + 24*60*60*1000*3);
    toDate = WorkOrderUtil.convertToyyyyMMddhhmmString(toDate);

    this.state = {
      page: 0,
      loading: false,
      pages: 0,
      pageSize: 10,
      spinnerVisible: false,
      fromDate: fromDate,
      toDate: toDate,
      workOrders: [],
      columns : [],
      subColumns: []
    };
  } 

  componentDidMount () {
    MasterDataService.retrieveAllStatus().then(data => {
      this.setState({ 
        columns : [
          {
            Header: couterpart.translate('item_info'),
            accessor: 'itemInfo',
            width: 150
          },{
            Header: couterpart.translate('changed_info'),
            accessor: 'itemField',
            width: 200,
            Cell: row =>(
              <div style={{ textAlign: "center" }}>
                &nbsp;
              </div>
            )
          },{
            Header: couterpart.translate('item_additional_info'),
            accessor: 'itemAdditionalInfo',
            width: 100,
            Cell: row =>(
              <div style={{ textAlign: "center" }}>
                &nbsp;
              </div>
            )                                                             
          },{           
            Header: couterpart.translate('origin_value'),
            accessor: 'originValue',
            filterable: false,
            width: 200,
            Cell: row =>(
              <div style={{ textAlign: "center" }}>
                &nbsp;
              </div>
            ) 
          },{
            Header: couterpart.translate('updated_value'),
            accessor: 'updatedValue',
            width: 200,
            Cell: row =>(
              <div style={{ textAlign: "center" }}>
                &nbsp;
              </div>
            ) 
          },{
            Header: couterpart.translate('created_at'),
            accessor: 'createdAt',
            width: 200,
            Cell: row =>(
              <div style={{ textAlign: "center" }}>
                &nbsp;
              </div>
            ) 
          },{
            Header: couterpart.translate('created_by'),
            accessor: 'createdBy',
            width: 200,
            Cell: row =>(
              <div style={{ textAlign: "center" }}>
                &nbsp;
              </div>
            )                         
          },{
            Header: couterpart.translate('history_note'),
            accessor: 'note',
            width: 200,
            Cell: row =>(
              <div style={{ textAlign: "center" }}>
                &nbsp;
              </div>
            )                         
          }                    
        ],
        subColumns: [
          {
            Header: "",
            accessor: "toggle",
            width: 35
          },
          {
            Header: couterpart.translate('item_info'),
            accessor: 'itemInfo',
            width: 150
          },{
            Header: couterpart.translate('item_additional_info'),
            accessor: 'itemAdditionalInfo',
            width: 100            
          },{
            Header: couterpart.translate('changed_info'),
            accessor: 'itemField',
            width: 200                                    
          },{           
            Header: couterpart.translate('origin_value'),
            accessor: 'originValue',
            filterable: false,
            width: 200,
            Cell: props => WorkOrderUtil.getValueDescription(data, props.value, props.original.itemField)
          },{
            Header: couterpart.translate('updated_value'),
            accessor: 'updatedValue',
            width: 200,
            Cell: props => WorkOrderUtil.getValueDescription(data, props.value, props.original.itemField)
          },{
            Header: couterpart.translate('created_at'),
            accessor: 'createdAt',
            width: 200
          },{
            Header: couterpart.translate('created_by'),
            accessor: 'createdBy',
            width: 200                        
          },{
            Header: couterpart.translate('history_note'),
            accessor: 'note',
            width: 200                        
          }
        ] 
      }) 
    });
    
    let fromDate =  WorkOrderUtil.getItem("prodKhac.fromDate")
    let toDate = WorkOrderUtil.getItem("prodKhac.toDate")

    const values = queryString.parse(this.props.location.search);
    let numOfMonths = 12;
    if (values !== undefined && values.status !== undefined){
      numOfMonths = 24;
    }
  
    if (values === undefined || (values.status === undefined && values.isback === undefined) || fromDate === null || fromDate === undefined) {
      let backTime = 30*24*60*60*1000*numOfMonths;
      fromDate = new Date(new Date().getTime() - backTime);//1 month
      fromDate = WorkOrderUtil.convertToyyyyMMddhhmmString(fromDate);
    }

    if (toDate === null || toDate === undefined) {
      toDate = new Date(new Date().getTime() + 24*60*60*1000);
      toDate = WorkOrderUtil.convertToyyyyMMddhhmmString(toDate);
    }

    this.setState({ 
      fromDate:  fromDate, 
      toDate: toDate
    }, () => {
      this.filterOrdersBy();
    });
  
  }   

  onFilter() {
    // this.clearSearchInfo();
    this.setState({ page: 0 });
    this.filterOrdersBy();
  }

  

  filterOrdersBy(){
    if ((this.state.selectedPage < 0) || (this.state.pageSize < 0)){
      return;
    }

    this.setState({ loading: true });
    let page = this.state.selectedPage === undefined? 0: this.state.selectedPage;
    let pageSize = this.state.pageSize === undefined? 10: this.state.pageSize;   

    HistoryService.fetchHistories(page, pageSize, this.state.fromDate, this.state.toDate, this.state.orderNo, this.state.pcode)
      .then(data => { 
      if(data.message === undefined && data !== undefined &&  data.histories instanceof Array){
        let group = data.histories.reduce((r, a) => {
          r[a.itemInfo] = [...r[a.itemInfo] || [], a];
          return r;
        }, {});
        console.log("group", group);
        let itemInfoList = []; 
        for (let key in group) {
          itemInfoList.push({
            itemInfo: key
          })
        }             
        this.setState({ workOrders: itemInfoList, group: group, spinnerVisible: false, loading: false, pages: data.totalPages, page: data.currentPage, pageSize: pageSize});
      }else{
        this.setState({ workOrders:  [], group: {}, loading: false, pages: 0, page: 0, pageSize: pageSize});
        ToastsStore.error(data.message);
      }   
    });
  } 

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  
  handleFromDateChange(date){
    let sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState({                 
      fromDate: sDate                   
    });
  }

  handleToDateChange(date){
    let sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState({                 
      toDate: sDate                   
    });
  }

  renderSubItems (row){
    let items = this.state.group[row.original.itemInfo];
    if (items === undefined || items === null){
      return (<></>);
    }
        
    return(
      <div className="row">
        <div className="col-12">        
        items.map(x => 
          <div className="row">
            <div className="col-2"> { this.state.group[row.original.itemInfo][0].id } </div>
          </div>
        )}
        </div>         
      </div>
    );
  }

  onResizedChange = newResized => {
    const { subColumns } = this.state;

    const columnsWidth = subColumns.map(column => {
      const currentColumn = newResized.find(
        resized => resized.id === column.accessor
      );
      if (currentColumn) {
        return {
          ...column,
          width: currentColumn.value
        };
      }
      return column;
    });
    this.setState({ subColumns: columnsWidth });
  }; 

  handleOrderNoChange(e){
    if (e.key === 'Enter') {
      this.onFilter()
      return;
    }    
    var value = e.target.value;
    this.setState({                 
      orderNo: value                   
    });
  }

  handlePcodeChange(e){
    if (e.key === 'Enter') {
      this.onFilter()
      return;
    }
    var value = e.target.value;
    this.setState({                 
      pcode: value                   
    });
  }

  handleKeyDown(e){
      if (e.key === 'Enter') {
          this.onFilter()
      }
  }      

  render() {
    if (!AuthenticationService.isKhac() &&!AuthenticationService.isSupervisor() && !AuthenticationService.isAdmin()){
      return (<div>Unauthorized access.</div>);
    }

    return (
          <div>
              <MenuComponent2/>
              <ToastsContainer store={ToastsStore} position="bottom_center" />
              <br/>
              <div className="row">
                <div className="col-12">
                  <div className="row" style={{ margin: "2px"}}>
                    <div className="col-4 border-top border-left border-right border-bottom border-light-gray" style={{ padding: '5px'}}>
                      <div className="row">
                        <div className="col-2">
                          <label><b>{couterpart.translate('order_date_from')}</b></label>:
                        </div>
                        <div className="col-3">
                          <div className="customDatePickerWidth">
                            <DatePicker name="orderDateFrom" 
                              dateFormat="MM/dd/yyyy hh:mm"              
                              selected={ WorkOrderUtil.convertToDate(this.state.fromDate)}
                              onChange={this.handleFromDateChange.bind(this)}/>
                          </div>
                        </div>
                        <div className="col-2"><label><b>{couterpart.translate('order_date_to')}</b></label></div>
                        <div className="col-3">
                          <div className="customDatePickerWidth">
                            <DatePicker name="orderDateTo" 
                              dateFormat="MM/dd/yyyy hh:mm"
                              selected={ WorkOrderUtil.convertToDate(this.state.toDate)}
                              onChange={this.handleToDateChange.bind(this)}/>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-2">
                      <input type="text" defaultValue={this.state.orderNo}  style={{ width: "100%"}}
                        placeholder={couterpart.translate('order_no')}
                        onChange={this.handleOrderNoChange.bind(this)} onKeyDown = {(e) => { e.persist(); setTimeout(() => { this.handleOrderNoChange(e) }, 0); }}/>
                    </div>
                    <div className="col-2">
                      <input type="text" defaultValue={this.state.pcode}  style={{ width: "100%"}}
                        placeholder={couterpart.translate('shop_pcode')}
                        onChange={this.handlePcodeChange.bind(this)} onKeyDown = {(e) => { e.persist(); setTimeout(() => { this.handlePcodeChange(e) }, 0); }}/>
                    </div>                               
                    <div className="col-2">
                      <button className="myButton" 
                        onClick={this.onFilter.bind(this)}>
                        <FaFilter color={ICON_COLOR}/>
                        &nbsp;{couterpart.translate('button_filter')}
                      </button>
                    </div>
                  </div>
                </div>
              </div>  
              <div className="row">
                <div className="col-12">
                  <ReactTable
                    manual
                    NoDataComponent={() => null} 
                    previousText={"<"}
                    nextText={">"}
                    onResizedChange={this.onResizedChange}
                    onPageChange={pageIndex => {
                      this.setState({ selectedPage: pageIndex }, () => {
                        this.filterOrdersBy()
                      })
                    }}
                    onPageSizeChange={(pageSize, pageIndex) => {
                      this.setState({ page: pageIndex, pageSize: pageSize }, () => {
                        this.filterOrdersBy()
                      });
                    }}
                    className="-striped -highlight"                             
                    data={this.state.workOrders}
                    loading= { this.state.loading }  
                    pages={ this.state.pages }
                    columns={this.state.columns}
                    defaultPageSize = {10}
                    showPageSizeOptions = {true}
                    pageSizeOptions = {[3, 5, 10, 20]}
                    SubComponent={row => {
                      let items = this.state.group[row.original.itemInfo];
                      return (
                        <ReactTable
                          data={items}
                          columns={this.state.subColumns}
                          TheadComponent={() => null}
                          defaultPageSize={items.length}
                          showPagination={false}
                        />
                      );
                      // let items = this.state.group[row.original.itemInfo];
                      // if (items === undefined || items === null){
                      //   return (<></>);
                      // }
                          
                      // return(
                      //   <div className="row">
                      //     <div className="col-12" style={{ marginLeft: "20px"}}>        
                      //     { items.map(x => 
                      //       <div className="row" key={ row.original.itemInfo + '_' + x.id}>
                      //         <div className="col-2"> { x.id } </div>
                      //         <div className="col-2"> { x.itemField } </div>
                      //         <div className="col-2"> { x.originValue } </div>
                      //         <div className="col-2"> { x.updatedValue } </div>
                      //         <div className="col-2"> { x.createdAt } </div>
                      //         <div className="col-2"> { x.createdBy } </div>
                      //       </div>
                      //     )}
                      //     </div>         
                      //   </div>
                      // );
                    }}
                  />
                </div>
              </div>
              <Spinner size={25} spinnerColor={ICON_COLOR} spinnerWidth={2} visible={this.state.spinnerVisible} />
              <Dialog ref={(component) => { this.dialog = component }} />
          </div>      
    )
  }
}
export default withRouter(HistoryList);